var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityAssistiveListening = function SvgAccessibilityAssistiveListening(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    vectorEffect: "non-scaling-stroke",
    width: 8.923,
    height: 8.923,
    x: 20.033,
    y: 17.711,
    strokeLinejoin: "round",
    rx: 4.461
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M23.5 20.5h2m-1 0v4"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinejoin: "round",
    d: "M8.717 12.561a3.937 3.937 0 1 1 5.933 4.858M7.411 25.45c.646.485 1.668 1.045 2.833.922 1.989-.207 2.757-1.327 3.49-2.722.546-1.04 1.538-2.394 2.139-3.167q.35-.455.789-.827l.103-.092a6.904 6.904 0 1 0-11.427-5.671"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m19.5 7.5 4-4m-21 21 5-5"
  }))));
};
export default SvgAccessibilityAssistiveListening;